if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      window.initScriptOnDemand(this, this.init.bind(this), 400);
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;
      let history = [];
      try {
        const stored = JSON.parse(localStorage.getItem('theme-recently-viewed') || '[]');
        if (Array.isArray(stored)) history = stored;
      } catch (error) {
        // Browsing history is optional; a disabled or malformed store must not break the page.
      }
      const limit = Math.max(1, Math.min(14, Number.parseInt(this.dataset.productLimit, 10) || 8));
      const exclude = Number(this.dataset.excludeProduct);
      this.products = [...new Set(history.filter(id => /^\d+$/.test(String(id))).map(Number))]
        .filter(id => Number.isSafeInteger(id) && id > 0 && id !== exclude).slice(0, limit);
      if (this.products.length) return this.fetchProducts();
    }

    disconnectedCallback() {
      if (this.request) {
        clearTimeout(this.request.timeout);
        this.request.controller.abort();
        this.request = null;
      }
      this.removeAttribute('aria-busy');
    }

    async fetchProducts() {
      if (this.request || !this.products.length) return;
      const request = { controller: new AbortController(), restoreFocus: this.contains(document.activeElement) };
      this.request = request;
      request.timeout = setTimeout(() => request.controller.abort(), 15000);
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[data-recently-viewed-retry]')?.setAttribute('disabled', '');
      try {
        const query = this.products.map(id => `id:${id}`).join(' OR ');
        const response = await fetch(`${this.dataset.searchUrl}&q=${encodeURIComponent(query)}`, { signal: request.controller.signal });
        if (!response.ok) throw new Error(`Recently viewed HTTP ${response.status}`);
        const html = await response.text();
        if (this.request !== request || !this.isConnected) return;
        const template = document.createElement('template');
        template.innerHTML = html;
        const section = template.content.querySelector('recently-viewed');
        if (!section) throw new Error('Recently viewed section missing');
        const grid = section.querySelector('ul.product-grid');
        if (!grid) {
          if (section.textContent.trim()) throw new Error('Recently viewed grid missing');
          this.innerHTML = '';
          return;
        }
        const cards = Array.from(grid.querySelectorAll('li[data-product-id]'));
        const sorted = this.products.map(id => cards.find(card => Number(card.dataset.productId) === id)).filter(Boolean);
        // Deleted/unpublished products can legitimately leave no displayable history.
        if (!sorted.length) {
          this.innerHTML = '';
          return;
        }
        grid.replaceChildren(...sorted);
        this.innerHTML = section.innerHTML;
        section.querySelectorAll('script').forEach(script => {
          const copy = document.createElement('script');
          if (script.src) copy.src = script.src;
          else copy.textContent = script.textContent;
          document.body.appendChild(copy);
        });
        window.renderSelects();
        window.loadDesktopOnlyTemplates();
        window.stickersReinit?.();
        if (request.restoreFocus) this.querySelector('h3 a, a[href]')?.focus({ preventScroll: true });
      } catch (error) {
        if (this.request === request && this.isConnected) this.renderError();
      } finally {
        clearTimeout(request.timeout);
        if (this.request === request) {
          this.request = null;
          this.removeAttribute('aria-busy');
          this.querySelector('[data-recently-viewed-retry]')?.removeAttribute('disabled');
        }
      }
    }

    renderError() {
      const wrapper = document.createElement('div');
      wrapper.className = 'page-width pt-s pb-s';
      const message = document.createElement('p');
      message.setAttribute('role', 'status');
      message.textContent = this.dataset.loadError || 'Son görüntülediğiniz ürünler yüklenemedi.';
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'button button--secondary';
      retry.setAttribute('data-recently-viewed-retry', '');
      retry.textContent = this.dataset.retryLabel || 'Yeniden dene';
      retry.addEventListener('click', () => this.fetchProducts());
      const restoreFocus = this.contains(document.activeElement);
      wrapper.append(message, retry);
      this.replaceChildren(wrapper);
      if (restoreFocus) retry.focus({ preventScroll: true });
    }
  });
}
